import {h, render} from 'preact';
import AppealForm from "../lk/components/forms/AppealForm";
import ServiceForm from "../lk/components/forms/ServiceForm";
import ServiceFormCertificateNoDebt from "../lk/components/forms/ServiceFormCertificateNoDebt";
import ServiceFormRenewalPersonalAccount from "../lk/components/forms/ServiceFormRenewalPersonalAccount";
import BusinessServiceRenewalForm from "../lk/components/forms/BusinessServiceRenewalForm";
import AppealCommentForm from "../lk/components/forms/AppealCommentForm";
import ServiceFormPromisedPayment from "../lk/components/forms/ServiceFormPromisedPayment";
import ServiceFormComplexCertificateNoDebt from "../lk/components/forms/ServiceFormComplexCertificateNoDebt";

document.addEventListener('DOMContentLoaded', function(){
	const appealForm = document.getElementById('appeal-form');
	if(appealForm && typeof window['preactAppealFormParams'] !== "undefined")
	{
		render(<AppealForm {...window['preactAppealFormParams']}/>, appealForm);
	}

	const serviceForm = document.getElementById('service-form');
	if(serviceForm && typeof window['preactServiceFormParams'] !== "undefined")
	{
		switch (window['preactServiceFormParams']['typeForm']){
			case 'formCertificateNoDebt':
				render(<ServiceFormCertificateNoDebt {...window['preactServiceFormParams']}/>, serviceForm);
				break;
			case 'formComplexCertificateNoDebt':
				render(<ServiceFormComplexCertificateNoDebt {...window['preactServiceFormParams']}/>, serviceForm);
				break;
			case 'formRenewalPersonalAccount':
				render(<ServiceFormRenewalPersonalAccount {...window['preactServiceFormParams']}/>, serviceForm);
				break;
			case 'formPromisedPayment':
				render(<ServiceFormPromisedPayment {...window['preactServiceFormParams']}/>, serviceForm);
				break;
			default:
				render(<ServiceForm {...window['preactServiceFormParams']}/>, serviceForm);
				break;
		}
	}

	const businessServiceRenewal = document.getElementById('business-service-renewal');
	if(businessServiceRenewal && typeof window['preactBusinessServiceRenewalParams'] !== "undefined")
	{
		render(<BusinessServiceRenewalForm {...window['preactBusinessServiceRenewalParams']}/>, businessServiceRenewal);
	}
});
window.renderAppealComment = function(params) {
	const appealComment = document.getElementById('appeal-comment');

	if(appealComment && typeof params !== "undefined")
	{
		render(<AppealCommentForm {...params}/>, appealComment);
	}
}